import { useTranslation } from 'react-i18next';
import { Post } from '@asset-metrix/portal-ui';

import { FullScreenFrame } from './FullScreenFrame';

export const FullScreenLoader = () => {
  const { t } = useTranslation();

  return (
    <FullScreenFrame loading>
      <Post>
        <h1>{t('app.tenantPortalDataLoading.headline')}</h1>
      </Post>
    </FullScreenFrame>
  );
};
